import * as Languages from 'constants/Language';

const localeMap = {
    [Languages.RU]: 'ru',
    [Languages.KY]: 'ky',
    [Languages.EN]: 'en',
    [Languages.TG]: 'tg',
    [Languages.KK]: 'kk',
    [Languages.UZ]: 'uz',
};

export default localeMap;



// WEBPACK FOOTER //
// ./js/constants/Locales.js